import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import config from 'devextreme/core/config';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { licenseKey } from './devextreme-license';

config({ licenseKey });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
